import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import './header.css';
import Nav from 'react-bootstrap/Nav';

function Header() {
    const location = useLocation();
    const navItems = [
        {
            id: "home",
            label: "Home",
            url: "/home"
        },
        {
            id: "task",
            label: "Task",
            url: "/task"
        },
        {
            id: "login",
            label: "Login",
            url: "/login"
        }
    ];

    return (<header className="header">
        <Nav className="nav" aria-label="Main Navigation">
            <ul className="nav-list">
                {navItems.map((item) => (<li key={item.id} role="presentation" className="nav-item">
                    {item.external ? (<a href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.label}
                    </a>) : (
                        <Link to={item.url} className={(location.pathname === "/" && item.url === "/home") || location.pathname.startsWith(item.url) ? 'active' : ''}>
                            {item.label}
                        </Link>
                    )}
                </li>))}
            </ul>
        </Nav>
    </header>);
}

export default Header;